import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';
import { CommitteeTypeDto } from './dto/committee-type.dto';

@Injectable({
  providedIn: 'root',
})
export class CommitteeTypeService {
  constructor(private _apiService: ApiService) {}

  getAllTypes(forceRefresh?: boolean): Promise<CommitteeTypeDto[]> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.get('CommitteeTypes', cacheOptions);
  }

  get(type: string): Promise<CommitteeTypeDto> {
    return this._apiService.get(`CommitteeType/${type}`);
  }

  create(dto: CommitteeTypeDto): Promise<string> {
    return this._apiService.post('CommitteeTypes', dto);
  }

  update(originalCommitteeType: string, dto: CommitteeTypeDto): Promise<void> {
    return this._apiService.put(`CommitteeType/${originalCommitteeType}`, dto);
  }

  delete(type: string): Promise<void> {
    return this._apiService.delete(`CommitteeType/${type}`);
  }
}
